import { render, staticRenderFns } from "./FoRW.vue?vue&type=template&id=5095096c"
import script from "./FoRW.vue?vue&type=script&lang=js"
export * from "./FoRW.vue?vue&type=script&lang=js"
import style0 from "./FoRW.vue?vue&type=style&index=0&id=5095096c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports